// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const se = {
  account: `account`,
  action: 'Åtgärd',
  active: 'Aktiva',
  // Client
  active_placement: 'Aktiv placering',
  // Common
  add: 'Lägg till',
  add_new: 'Lägg till ny',
  address: 'Adress',
  administrator: 'Administratör',
  age: 'Ålder',
  agreement_exists: 'Ramavtal existerar',
  agreement_legal_basis: 'Lagrum till stöd för insats',
  all: 'Alla',
  all_clear: 'Rensa allt',

  amount_of_placements: 'Antalet placeringar',

  amount_of_register_leaders: 'Antalet registreringsledare',

  animal_description: 'Beskriv djuret',

  animals: 'Husdjur',

  app: `app`,

  back_to_list: 'Tillbaka till listan',

  bank: 'Bank',

  bank_account_number: 'Kontonummer',

  banking: `banking`,

  blog: `blog`,

  booking: `booking`,

  BUSINESS_ENTITY: 'Affärsenhet',

  calendar: `calendar`,

  cancel: 'Avbryt',

  cards: `cards`,

  care_fee_per_day: 'Dygnsavgift',

  case_manager: 'Handläggare',

  certain_interest: 'Speciella intressen',

  change: 'Byt',

  // User
  change_password: 'Ändra lösenord',

  chat: `chat`,

  citizenship: 'Nationalitet',

  city: 'Ort',

  // Documents
  clear: 'Klar',

  client: 'Klient',

  client_id: 'Besluts ID',

  clients: 'Klienter',
  close: 'Stänga',

  close_extended_search: 'Stäng utökad sökning',

  closing_date: 'Avslutsdatum',

  // Company
  company: 'Företaget',

  competence: 'Kompetens/Utbildning',

  confirm_delete_row_msg: 'Är du säker på att du vill radera detta objekt',

  confirm_delete_rows_msg: 'Är du säker på att du vill radera?',

  confirm_delete_rows_msg_items: 'objekten?',

  confirm_password: 'Bekräfta lösenordet',

  contact_person: 'Kontaktperson',

  contact_persons: 'Kontaktpersoner',

  copy_link: 'Kopiera länk',

  create: `create`,

  create_an_account: 'Skapa ett konto',

  create_new_folder: 'Ny mapp',

  current_password: 'Nuvarande lösenord',

  custom: 'Beställnings',

  // Customer
  customer: 'Uppdragsgivare',

  customers: 'Uppdragsgivare',

  dashboard: 'Startsida',

  date_of_sign_up: 'Registreringsdatum',

  date_of_signup: 'Registreringsdatum',

  date_range: 'Datumintervall',

  delete: 'Radera',

  description: 'Beskrivning',

  details: `details`,

  do_you_want_to_stay_log_in: 'Vill du stanna inloggad?',

  docs: {
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
    hi: `Hi`,
  },

  document_type: 'Dokumenttyp',

  documents: 'Dokument',

  // Dashboard
  documents_duedate: 'Dokument förfallodatum',

  download: 'Ladda ner',

  due_date: 'Förfallodatum',

  edit: 'Ändra',

  email: 'E-post',

  email_address: 'E-postadress',

  end: 'Avsluta',

  end_date: 'Avslutsdatum',

  end_placement: 'Avsluta placering',

  ended: 'Avslutad',

  enter_keyword: 'Ange nyckelord',

  error: 'Error',

  extended_search: 'Utökad sökning',

  extra_reinforced_family_home: 'Extra förstärkt familjehem',

  family_home: 'Familjehem',

  female: 'Kvinna',

  file_name: 'Filnamn',

  files: 'Filer',

  first_name: 'Förnamn',

  folder: 'Mapp',

  folders: 'Mappar',

  forgot_password: 'Glömt lösenordet?',

  foster_families: 'Familjehem',

  foster_family: 'Familjehem',

  FRAMEWORK_AGREEMENT: 'Ramavtal',

  from: 'Från',

  full: 'Fullt',

  gender: 'Kön',

  general: `general`,

  gross_salary: 'Bruttolön',

  has_animals: 'Har hemmet husdjur?',

  HAS_ASSIGNMENT_AGREEMENT: 'Har uppdragsavtal',

  HAS_PLACEMENT_AGREEMENT: 'Har placeringavtal',

  has_smokers: 'Har hemmet rökare?',

  home: 'Dashboard',

  implementation_plan: 'Genomförandeplan',

  inactivated: 'Inaktiverad',

  inactive: 'Inaktiv',

  internal_comments: 'Interna kommentarer',

  invoice: `invoice`,

  invoice_address: 'Fakturaadress',

  invoice_city: 'Ort',

  invoice_postcode: 'Postnummer',

  IS_READY: 'Redo',

  is_required: 'krävs',

  // Shared Document
  issuer: 'Utfärdare',

  item_by_roles: `item by roles`,

  item_caption: `item caption`,

  item_disabled: `item disabled`,

  item_external_link: `item external link`,

  item_label: `item label`,

  joined: 'Registrerad',

  kanban: `kanban`,

  language_spoken: 'Talade språk',

  last_month: 'Förra månaden',

  last_name: 'Efternamn',

  last_year: 'Förra året',

  last30: 'Senaste 30 dagarna',

  last7: 'Senaste 7 dagarna',

  last90: 'Senaste 90 dagarna',

  list: 'listan',

  login: 'Logga in',

  logout: 'Logga ut',

  mail: `mail`,

  main_password: 'Huvudlösenord',

  male: 'Man',

  management: `Förvaltning`,

  manager: 'Handläggare',

  managers: 'Handläggare',

  menu_level: `menu level`,

  menu_level_2a: `menu level 2a`,

  menu_level_2b: `menu level 2b`,

  menu_level_3a: `menu level 3a`,

  menu_level_3b: `menu level 3b`,

  menu_level_4a: `menu level 4a`,

  menu_level_4b: `menu level 4b`,

  message: 'Meddelande',

  mobile_phone_number: 'Mobilnummer',

  modified: 'Ändrad',

  month_to_date: 'En Månad Till Dagens Datum',

  mother_language: 'Moderspråk',

  MUNICIPALITY: 'Kommun',

  name: 'Namn',

  new: 'Ny',

  // Foster Family
  new_foster_family: 'Nytt familjehem',

  new_password: 'Nytt lösenord',

  new_user: 'Ny användare?',

  next_step: 'Nästa steg',

  no: 'Nej',

  no_data: 'Inga data',

  NOTES: 'Kommentarer',

  // Meddelanden
  notification: {
    failure: {
      default: 'Misslyckades',
      upload: 'Uppladdningen misslyckades!',
    },
    info: {
      copy: 'Kopierat',
    },
    success: {
      change_password: 'Lösenordet ändrades framgångsrikt!',
      create: 'Skapades framgångsrikt!',
      delete: 'Raderades framgångsrikt!',
      save: 'Spara framgångsrikt!',
      send_email: 'Skickade ett e-postmeddelande framgångsrikt!',
      send_share_email: 'Skickade ett delnings-e-postmeddelande framgångsrikt!',
      set_password: 'Lösenordet har ställts in!',
      update: 'Uppdaterades framgångsrikt!',
      upload: 'Uppladdningen lyckades!',
    },
    warning: {
      invalid_url: 'Ogiltig url!',
      no_company: 'Kan inte hitta det nuvarande företaget!',
      no_logout: 'Kan inte logga ut!',
    },
  },

  nursing_home: 'Jourhem',

  only_admin_can_see_this_item: `Only admin can see this item`,

  open: 'Öppna',

  org_name: 'Organisationsnamn',

  organization_name: 'Organisationsnamn',

  organization_number: 'Organisationsnummer',

  other_cases: `other cases`,

  other_info_about_placement: 'Övrig info om placeringen',

  other_information: 'Övrig info',

  overhead_per_day: 'Omkostnadsersättning per dag',

  overhead_per_month: 'Omkostnadsersättning per månad',

  password: 'Lösenord',

  PAYROLL_SCHEDULE: 'Löneschema',

  pending: 'Under utredning',

  personal_number: 'Personnummer',

  phone: 'Telefon',

  phone_number: 'Telefonnummer',

  place: 'Plats',

  // Placement
  placement: 'Placering',

  placement_agreement: 'Placeringsavtal',
  placement_character: 'Placeringens karaktär',

  placement_date: 'Placeringsdatum',

  PLACEMENT_NOT_READY_EXPLANATION:
    'Placeringen är inte redo. Placeringen måste ha ett besluts-id, ett uppdragsavtal och ett placeringavtal.',

  PLACEMENT_TYPE: 'Placeringstyp',

  placements: 'Placeringar',

  post: `post`,

  postcode: 'Postnummer',

  posts: `posts`,

  PRICE_SEK: '{{value}} kr',

  product: `product`,

  PROFILE: 'Profil',

  // Profile
  profile: 'Profil',

  profiles: 'Profiler',

  purpose_of_insertion: 'Syfte med insats',

  rank: 'Rang',

  ready: 'Redo',

  reason: 'Anledning',

  reason_for_insertion: 'Anledning till insats',

  register_leader: 'Registerledare',

  reinforced_family_home: 'Förstärkt familjehem',

  relationship: 'Relation',

  rename: 'namnändra',

  require_select_customer_msg:
    'Du måste välja kund innan du väljer Handläggare',

  reset: 'Återställa',

  // Reset Password
  reset_password: 'Återställ lösenord',

  responsibility: 'Ansvarig',

  responsible: 'Ansvarig',

  responsible_party: 'Välj ansvarig',

  role: 'Roll',

  rows: 'Rader',

  rows_per_page: 'Rader per sida',

  salary_per_day: 'Lön per dag',

  salary_per_month: 'Lön per månad',

  save: 'Spara',

  save_changes: 'Spara ändringar',

  search: 'Sök',

  secure_identity: 'Skyddad identitet',

  select: 'Välj',

  select_all: 'Välj alla',

  select_date: 'Välj Datum',

  select_date_range: 'Välj Datumintervall',

  send_encrypted: 'Skicka krypterat',

  set_password: 'Ange lösenord',

  settings: 'Inställningar',

  share: 'Dela',

  shop: `shop`,

  show_description: 'Visa beskrivning',

  // Login
  sign_in_to_safepoint: 'Logga in i Safepoint',

  smokers: 'Rökare',

  social_register_data: 'Socialregisteruppgifter',

  social_security_number: 'Personnummer',

  social_worker: 'Familjehemskonsulent',

  staff: 'Övrig personal',

  start_date: 'Startdatum',

  state: 'Län',

  status: 'Status',

  step: 'Steg',

  support_nearby_living: 'Stöd/Bredvidboende',

  surname: 'Efternamn',

  SWITCH_COMPANY: 'Växla företag',

  the_bailiff: 'Kronofogden',

  the_insurance_fund: 'Försäkringskassan',

  the_police: 'Misstanke och Belastningsregister',

  the_swedish_transport_agency: 'Transportstyrelsen',

  to: 'Till',

  today: 'I dag',

  tools: 'Verktyg',

  total_active_placements_from_others:
    'Antal befintliga pågående placeringar via andra företag/kommuner',

  total_adults_in_home: 'Antal vuxna i hemmet',

  total_adults_reduced_working_hours_due_to_placement:
    'Antal vuxna som gått ner i tjänst pga placering',

  total_free_rooms_in_home: 'Antal lediga rum i hemmet',

  total_own_children_in_home: 'Antalet egna barn i hemmet',

  total_placement_capacity_in_the_home:
    'Antal placeringar hemmet har kapacitet för',

  total_placements_capacity_for_our_company:
    'Antal befintliga pågående placeringar via oss',

  total_rooms_in_home: 'Antal rum i hemmet',

  treatment_family: 'Behandlingsfamilj',

  type: 'Typ',

  type_of_insertion: 'Typ av insats',

  unit: 'Enhet',

  unknown: 'Okänt',

  upload_file: 'Ladda upp fil',

  uploading: 'Laddar up',

  user: 'Användare',

  users: 'Användare',

  validate: 'Validera',

  vault: 'Valv',

  verification_password: 'Verifieringskod',

  view: 'Visa',

  visiting_address: 'Besöksadress',

  visiting_city: 'Ort',

  visiting_postcode: 'Postnummer',

  warning: 'Varning',

  week: 'Vecka',

  week_to_date: 'En Vecka Till Dagens Datum',

  year_to_date: 'Ett År Till Dagens Datum',

  yes: 'Ja',

  yesterday: 'I går',

  // Idle Warning
  you_have_been_inactive: 'Du har varit inaktiv och kommer bli utloggad snart',
};

export default se;
